module.exports = __webpack_public_path__ + "static/media/leukaemiaUK.021141ce.png";